import User from "users/entities/user/user";

export default class RegisterAPIRequest {
  userId: string;

  constructor(user: User) {
    if (!user.id) throw new Error("User must have an id to register");
    this.userId = user.id.value;
  }
}
